// ----------------------------------------COMPONENT HIERARCHY----------------------------------------
// ReportManagerContainer
//     ReportManager
//         ReportManagerForm

import ReportManagerContainer from "./ReportManagerContainer.js";

export default ReportManagerContainer;
